/**
 * Frontend functionality for Cover block mobile image feature.
 * 
 * Implements responsive image switching based on viewport width and user-defined breakpoints.
 * Handles CSS custom property injection and responsive class management.
 */

document.addEventListener('DOMContentLoaded', function() {
	// Find all cover blocks with mobile image data
	const coverBlocks = document.querySelectorAll('.wp-block-cover[data-mobile-image-url]');

	coverBlocks.forEach(function(coverBlock) {
		const mobileImageUrl = coverBlock.getAttribute('data-mobile-image-url');
		const mobileFocalPoint = coverBlock.getAttribute('data-mobile-focal-point');
		const mobileBreakpoint = parseInt(coverBlock.getAttribute('data-mobile-breakpoint')) || 667;

		if (mobileImageUrl) {
			// Add the mobile image class
			coverBlock.classList.add('has-mobile-image');

			// Set CSS custom properties for mobile image
			coverBlock.style.setProperty('--mobile-image-url', `url(${mobileImageUrl})`);

			// Set focal point if provided
			if (mobileFocalPoint) {
				try {
					const focalPoint = JSON.parse(mobileFocalPoint);
					const focalPointCSS = `${focalPoint.x * 100}% ${focalPoint.y * 100}%`;
					coverBlock.style.setProperty('--mobile-focal-point', focalPointCSS);
				} catch (e) {
					// Fallback to center if focal point parsing fails
					coverBlock.style.setProperty('--mobile-focal-point', 'center');
				}
			}

			// Function to handle responsive behavior
			function handleResponsiveDisplay() {
				if (window.innerWidth >= mobileBreakpoint) {
					// Desktop: show desktop image, hide mobile image
					coverBlock.classList.add('show-desktop-image');
				} else {
					// Mobile: show mobile image, hide desktop image
					coverBlock.classList.remove('show-desktop-image');
				}
			}

			// Initial check
			handleResponsiveDisplay();

			// Listen for window resize
			window.addEventListener('resize', handleResponsiveDisplay);
		}
	});
});
